<template>
    <div class="row" v-if="$store.state.user.role === 'admin' || $store.state.user.role === 'dravetnet'">
        <div class="col-md-12">
            <div class="card">
            <div class="card-header">
                <h2>{{ $t("labels.seizureSearch") }}</h2>
            </div>
            <div class="card-body">
                <div class="px-3">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="startDate">{{ $t("labels.startDate") }}</label>
                                <date-picker v-model="seizureFilters.startDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                            </div>
                            <div class="form-group">
                                <label for="endDate">{{ $t("labels.endDate") }}</label>
                                <date-picker v-model="seizureFilters.endDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                            </div>
                            <div class="form-group">
                                <label for="status">{{ $t("labels.status") }}</label>
                                <div class="position-relative has-icon-left">
                                    <select class="form-control" v-model="seizureFilters.status">
                                    <option value="nofilter">{{ $t("labels.nofilter") }}</option>
                                    <option value="lazy">{{ $t("labels.lazy") }}</option>
                                    <option value="awake">{{ $t("labels.awake") }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="status">{{ $t("labels.type") }}</label>
                                <div class="position-relative has-icon-left">
                                    <select class="form-control" v-model="seizureFilters.type">
                                        <option value="nofilter">{{ $t("labels.nofilter") }}</option>
                                        <option :value="type._id" v-for="type in types" :key="type._id">{{ type.name[$i18n.locale] ? type.name[$i18n.locale] : type.name['en'] }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="custom-control custom-checkbox bottom-space">
                                <input type="checkbox" class="custom-control-input" id="durationFilter" v-model="seizureFilters.durationFilter">
                                <label class="custom-control-label float-left" for="durationFilter">{{ $t("labels.durationFilter") }}</label>
                            </div>
                            <div class="form-group" v-if="seizureFilters.durationFilter">
                                <select class="form-control" v-model="seizureFilters.duration">
                                    <option :value="duration._id" v-for="duration in durations" :key="duration._id">{{ duration.name[$i18n.locale] ? duration.name[$i18n.locale] : duration.name['en'] }}</option>
                                </select>
                            </div>
                            <div class="custom-control custom-checkbox bottom-space">
                                <input type="checkbox" class="custom-control-input" id="blockedWithDrugs" v-model="seizureFilters.blockedWithDrugs">
                                <label class="custom-control-label float-left" for="blockedWithDrugs">{{ $t("labels.blockedWithDrugs") }}</label>
                            </div>
                            <div class="form-group bottom-space" v-if="seizureFilters.blockedWithDrugs">
                                <label for="seizureDrug">{{ $t("labels.lifeSavingDrug") }}</label>
                                <select class="form-control" v-model="seizureFilters.lifeSavingDrug">
                                    <option value="nofilter">{{ $t("labels.nofilter") }}</option>
                                    <option v-for="drug in drugs" :value="drug._id" :key="drug._id">{{ drug.name[$i18n.locale] ? drug.name[$i18n.locale] : drug.name['en'] }}</option>
                                </select>
                            </div>
                            <div class="form-actions">
                                <a href="" @click.prevent="seizureSearch" class="btn btn-success">Search</a>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-6">
                                    <p>
                                    <strong>Seizures:</strong> {{ seizureSearchResults.length }}
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                    <strong>Patients:</strong> {{ uniquePatients.length }}
                                    </p>
                                </div>
                            </div>
                            <table class="table table-responsive-sm">
                                <thead>
                                    <th>
                                        Patient short id
                                    </th>
                                    <th>
                                        Seizure type
                                    </th>
                                    <th>
                                        Blocked with drugs
                                    </th>
                                </thead>
                                <tbody>
                                    <tr v-for="s in seizureSearchResults" :key="s._id">
                                        <td>
                                            <a href="" @click.prevent="seizureDetails(s)">
                                                {{ s.patientId.shortId }}
                                            </a>
                                        </td>
                                        <td>{{ s.type.name[$i18n.locale] ? s.type.name[$i18n.locale] : s.type.name["en"] }}</td>
                                        <td>{{ s.blockedWithDrugs ? 'Yes' : 'No' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>  
    </div>
</template>

<script>
import SeizureService from '@/services/seizure'
import LovService from '@/services/lov'
import moment from 'moment'

export default {
    data() {
        return {
            seizureSearchResults: [],
            uniquePatients: [],
            types: [],
            drugs: [],
            durations: [],
            seizureFilters: {
                startDate: '',
                endDate:  '',
                status: 'nofilter',
                type: 'nofilter',
                durationFilter: false,
                durationMin: 0,
                durationMax: 0,
                blockedWithDrugs: false,
                lifeSavingDrug: 'nofilter'
            }
        }
    },
    methods: {
        seizureSearch: async function() {
            let results = await SeizureService.search(this.seizureFilters)
            if (results) {
                this.seizureSearchResults = results.data
                this.uniquePatients = [...new Set(this.seizureSearchResults.map(function (seizure) { return seizure.patientId.shortId }))]
            }
        },
        seizureDetails(s) {
          this.$router.push({ name: 'showSeizure', params: { id: s._id }})
        }
    },
    mounted: async function() {
        await this.seizureSearch()
        let drugs = await LovService.all('life_saving_drug', false)
        if (drugs) {
            this.drugs = drugs.data
        }
        let lovTypes = await LovService.all('seizure', false)
        if (lovTypes) {
            this.types = lovTypes.data
        }
        let durations = await LovService.all('duration', false)
        if (durations) {
            this.durations = durations.data
        }
    },
    created() {
        this.seizureFilters.startDate = moment(new Date()).startOf('month').format('YYYY-MM-DD')
        this.seizureFilters.endDate = moment(new Date()).endOf('month').format('YYYY-MM-DD')
    }
}
</script>

